module.exports = __webpack_public_path__ + "static/media/SWSCRC6-3.8a4c58b7.mp3";